/* @ngInject */
const local = (
  storageHandler,
  valueHandler
) => {
  const self = {}

  self.saveCurrentId = (_id) => {
    if (valueHandler.isId(_id)) {
      storageHandler.save('currentTrainId', _id)
    } else if (valueHandler.isId(_id.id)) {
      storageHandler.save('currentTrainId', _id.id)
    }
  }

  self.getCurrentId = () => {
    return storageHandler.get('currentTrainId')
  }

  return self
}

export default local



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/train/services/local.service.js